<template lang="pug">
  menu-item(:label=`$t('image_cutout')`, v-model="module.showWindow", keybind="shift+M")
</template>


<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  props: {
    module: { required: true },
  },
})
</script>


<i18n>
en:
  image_cutout: Image Cutout
ja:
  image_cutout: FITS切り出し

</i18n>